import {
  generateRandomNumber,
  generateRandomNumberWithout
} from '@helpers/random'
import WizardLoadingImage from '@images/landings/wizard/wizard_error_image.svg'
import { useWizardContext } from '@pages/Landings/routes/Landings/CreateLandingWizard/contexts'
import { LANDINGS } from '@routes/path'
import { Button, Heading, Hint, Image, Paragraph, Spacer } from '@ui-kit'
import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import { Column, Row } from 'simple-flexbox'

import styles from '../WizardGenerationLayout.module.scss'
import { Loader } from './components/Loader'

const WizardError = () => {
  const { submit } = useWizardContext()
  const { t } = useTranslation()

  return (
    <Row className={styles['wizard-survey-layout']} justifyContent='center'>
      <Row className={styles['wizard-survey-layout__content']}>
        <Column
          className={styles['wizard-survey-layout__first-column']}
          justifyContent='center'
        >
          <Column className={styles['error-content']} alignItems='start'>
            <Heading level={2}>{t('wizard.error.page.title')}</Heading>

            <Spacer space={15} />

            <Paragraph size={14}>
              {t('wizard.error.page.description')}
            </Paragraph>

            <Spacer space={30} />

            <Button onClick={() => submit({ isGeneratePossible: true })}>
              {t('wizard.error.page.button')}
            </Button>
          </Column>
        </Column>
        <Row className={styles['wizard-survey-layout__second-column']}>
          <Row
            className={styles['wizard-survey-layout__second-column-content']}
            alignItems='center'
            justifyContent='center'
          >
            <Image src={WizardLoadingImage} />
          </Row>
        </Row>
      </Row>
    </Row>
  )
}

const hints = [
  'wizard.generating.hint.1.v2',
  'wizard.generating.hint.2.v2',
  'wizard.generating.hint.3.v2'
]

export const WizardGenerationLayoutV2 = () => {
  const { generationStatus } = useWizardContext()

  const [hintTextKey, setHintsTextKey] = useState(
    hints[generateRandomNumber({ min: 0, max: hints.length - 1 })]
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const hintNumber = generateRandomNumberWithout({
        min: 0,
        max: hints.length - 1,
        without: hints.indexOf(hintTextKey)
      })

      setHintsTextKey(hints[hintNumber])
    }, 30000)

    return () => clearInterval(interval)
  }, [hintTextKey])

  if (!generationStatus) {
    return <Navigate to={LANDINGS.LANDINGS_CREATE_WIZARD_FIRST} />
  }

  if (generationStatus === 'error') {
    return <WizardError />
  }

  return (
    <Row className={styles['wizard-survey-layout']} justifyContent='center'>
      <Row className={styles['wizard-survey-layout__content']}>
        <Column
          className={styles['wizard-survey-layout__first-column']}
          justifyContent='center'
        >
          <Hint isTip keyProp={hintTextKey}>
            <Trans i18nKey={hintTextKey} />
          </Hint>
        </Column>
        <Row className={styles['wizard-survey-layout__second-column']}>
          <Row
            className={styles['wizard-survey-layout__second-column-content']}
            alignItems='center'
            justifyContent='center'
          >
            <Loader isFinished={generationStatus === 'finished'} />
          </Row>
        </Row>
      </Row>
    </Row>
  )
}
